import BaseModelAPI from '../BaseModelAPI';

export default class ApproverTypeList extends BaseModelAPI {

	static entity = 'approvertypelist'
	static entityName = 'approvertype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
